import { useAutoRefresh } from "../hooks/use-auto-refresh";

/**
 * AutoRefreshManager component
 *
 * Renderless component that runs the auto-refresh lifecycle so newly published
 * builds are picked up transparently. Renders nothing.
 */
export const AutoRefreshManager = () => {
  useAutoRefresh();

  return null;
};
